import React from 'react';
import ReactDOM from 'react-dom';
import Home from './components/home';
import { Route, HashRouter, Routes } from 'react-router-dom';
import Register from './components/register';
import Login from './components/login';
import ForgotPassword from './components/forgotpassword';
import { ToastContainer } from 'react-toastify';
import { createRoot } from 'react-dom/client';
let root = createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <ToastContainer />
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register/:ref" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/*" element={<Home />} />
    </Routes>
  </HashRouter>
);

